import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';

export const TableRowStyled = styled(TableRow, {
  name: 'ConnectionsTableRowStyled',
})(() => ({}));

export const TableCellStyled = styled(TableCell, {
  name: 'ConnectionsTableCellStyled',
})(({ theme }) => ({
  padding: theme.spacing(2, 1.5),
}));

export const TableCellNameStyled = styled(TableCell, {
  name: 'ConnectionsTableCellNameStyled',
})(({ theme }) => ({
  minWidth: 200,
  width: '25%',
  fontWeight: theme.typography.fontWeightMedium,
}));
